import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const heroSlides = [
  {
    port: "New York Port",
    flag: "🇺🇸",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Start Sourcing Now",
    ctaPath: "/marketplace",
    stat: { value: "600M+", label: "Global Buyers" },
    image: "https://public.readdy.ai/ai/img_res/9fc48dc0253b8e0302b79dc2ee6b2aea.jpg",
  },
  {
    port: "Port of Los Angeles",
    flag: "🇺🇸",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Browse Factories",
    ctaPath: "/marketplace",
    stat: { value: "20M+", label: "Verified Factories" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Los%20Angeles%20California%20beautiful%20bright%20sunny%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20Pacific%20Ocean%20blue%20sky%20stunning%20panoramic%20professional%20photography%20vibrant%20colors%20golden%20hour%20warm%20light&width=1600&height=750&seq=port_losangeles_02&orientation=landscape",
  },
  {
    port: "Port of Felixstowe, England",
    flag: "🇬🇧",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "View Products",
    ctaPath: "/product-listings",
    stat: { value: "190+", label: "Countries Served" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Felixstowe%20England%20UK%20beautiful%20bright%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20North%20Sea%20stunning%20blue%20sky%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20colors%20modern%20port%20golden%20sunlight&width=1600&height=750&seq=port_england_03&orientation=landscape",
  },
  {
    port: "Port of Sydney",
    flag: "🇦🇺",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Get Free Quote",
    ctaPath: "/buyer-post",
    stat: { value: "$2.8T+", label: "Annual Trade Volume" },
    image: "https://readdy.ai/api/search-image?query=Sydney%20Harbour%20port%20Australia%20beautiful%20bright%20sunny%20day%20aerial%20view%20Opera%20House%20Harbour%20Bridge%20container%20ships%20cargo%20vessels%20stunning%20blue%20sky%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20colors%20warm%20golden%20light&width=1600&height=750&seq=port_sydney_04&orientation=landscape",
  },
  {
    port: "Port of Singapore",
    flag: "🇸🇬",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Join as Factory",
    ctaPath: "/membership",
    stat: { value: "50M+", label: "Containers Shipped" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Singapore%20beautiful%20bright%20sunny%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20stunning%20blue%20sky%20city%20skyline%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20colors%20world%20busiest%20port%20golden%20sunset&width=1600&height=750&seq=port_singapore_05&orientation=landscape",
  },
  {
    port: "Port of Dubai, UAE",
    flag: "🇦🇪",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Source Products",
    ctaPath: "/marketplace",
    stat: { value: "180+", label: "Trade Routes" },
    image: "https://readdy.ai/api/search-image?query=Dubai%20Jebel%20Ali%20port%20UAE%20beautiful%20bright%20sunny%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20Persian%20Gulf%20stunning%20blue%20sky%20city%20skyline%20Burj%20Khalifa%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20golden%20colors%20modern%20port&width=1600&height=750&seq=port_dubai_06&orientation=landscape",
  },
  {
    port: "Port of Rotterdam",
    flag: "🇳🇱",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Find Suppliers",
    ctaPath: "/marketplace",
    stat: { value: "15M+", label: "TEU Capacity" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Rotterdam%20Netherlands%20beautiful%20bright%20day%20aerial%20view%20Europe%20largest%20port%20container%20terminal%20cargo%20ships%20North%20Sea%20stunning%20blue%20sky%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20colors%20modern%20industrial%20golden%20light&width=1600&height=750&seq=port_rotterdam_07&orientation=landscape",
  },
  {
    port: "Port of Tokyo, Japan",
    flag: "🇯🇵",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Explore Market",
    ctaPath: "/marketplace",
    stat: { value: "40M+", label: "Products Listed" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Tokyo%20Japan%20beautiful%20bright%20sunny%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20Tokyo%20Bay%20Mount%20Fuji%20skyline%20stunning%20blue%20sky%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20colors%20golden%20sunrise%20modern%20city&width=1600&height=750&seq=port_tokyo_08&orientation=landscape",
  },
  {
    port: "Port of Hamburg, Germany",
    flag: "🇩🇪",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Post Requirement",
    ctaPath: "/buyer-post",
    stat: { value: "24hrs", label: "Quote Response" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Hamburg%20Germany%20beautiful%20bright%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20Elbe%20River%20stunning%20blue%20sky%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20colors%20modern%20European%20port%20golden%20afternoon%20light%20city%20skyline&width=1600&height=750&seq=port_hamburg_09&orientation=landscape",
  },
  {
    port: "Port of Shanghai, China",
    flag: "🇨🇳",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "View Factories",
    ctaPath: "/marketplace",
    stat: { value: "45M+", label: "TEU World #1" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Shanghai%20China%20beautiful%20bright%20sunny%20day%20aerial%20view%20world%20largest%20container%20terminal%20cargo%20ships%20Yangtze%20River%20stunning%20blue%20sky%20Pudong%20skyline%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20golden%20colors%20modern%20port&width=1600&height=750&seq=port_shanghai_10&orientation=landscape",
  },
  {
    port: "Port of Busan, South Korea",
    flag: "🇰🇷",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Start Trading",
    ctaPath: "/marketplace",
    stat: { value: "22M+", label: "TEU Annual" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Busan%20South%20Korea%20beautiful%20bright%20sunny%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20Korea%20Strait%20stunning%20blue%20sky%20city%20skyline%20mountains%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20golden%20colors%20modern%20port&width=1600&height=750&seq=port_busan_11&orientation=landscape",
  },
  {
    port: "Port of Mumbai, India",
    flag: "🇮🇳",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Browse Products",
    ctaPath: "/product-listings",
    stat: { value: "1.4B+", label: "Market Reach" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Mumbai%20India%20beautiful%20bright%20sunny%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20Arabian%20Sea%20stunning%20blue%20sky%20city%20skyline%20Gateway%20of%20India%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20golden%20colors%20modern%20port&width=1600&height=750&seq=port_mumbai_12&orientation=landscape",
  },
  {
    port: "Port of Santos, Brazil",
    flag: "🇧🇷",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Get Free Quote",
    ctaPath: "/buyer-post",
    stat: { value: "4M+", label: "TEU Capacity" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Santos%20Brazil%20beautiful%20bright%20sunny%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20Atlantic%20Ocean%20stunning%20blue%20sky%20tropical%20city%20skyline%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20golden%20colors%20South%20America%20largest%20port&width=1600&height=750&seq=port_santos_13&orientation=landscape",
  },
  {
    port: "Port of Antwerp, Belgium",
    flag: "🇧🇪",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Join Platform",
    ctaPath: "/membership",
    stat: { value: "12M+", label: "TEU Annual" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Antwerp%20Belgium%20beautiful%20bright%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20Scheldt%20River%20stunning%20blue%20sky%20European%20city%20skyline%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20golden%20colors%20historic%20modern%20port&width=1600&height=750&seq=port_antwerp_14&orientation=landscape",
  },
  {
    port: "Port of Cape Town, South Africa",
    flag: "🇿🇦",
    title: "Crown Global Factory & Buyer",
    highlight: "Best Platform",
    subtitle: "Tens of millions of buyers purchase containers directly from factories worldwide — the world's #1 factory-to-buyer trade platform.",
    cta: "Explore Africa Trade",
    ctaPath: "/marketplace",
    stat: { value: "54+", label: "African Markets" },
    image: "https://readdy.ai/api/search-image?query=Port%20of%20Cape%20Town%20South%20Africa%20beautiful%20bright%20sunny%20day%20aerial%20view%20container%20terminal%20cargo%20ships%20Atlantic%20Ocean%20Table%20Mountain%20stunning%20blue%20sky%20dramatic%20professional%20photography%20wide%20angle%20vibrant%20golden%20colors%20iconic%20landscape&width=1600&height=750&seq=port_capetown_15&orientation=landscape",
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % heroSlides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, [current]);

  const goTo = (idx: number) => {
    if (animating || idx === current) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(idx);
      setAnimating(false);
    }, 300);
  };

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[520px] md:h-[720px] overflow-hidden">
      {/* Background images */}
      {heroSlides.map((s, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${i === current ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={s.image}
            alt={s.port}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      {/* Gold overlay — entire hero background is gold-tinted */}
      <div className="absolute inset-0 z-10" style={{background: "linear-gradient(135deg, rgba(180,110,0,0.82) 0%, rgba(245,180,20,0.75) 40%, rgba(212,140,0,0.80) 70%, rgba(160,90,0,0.88) 100%)"}}></div>
      <div className="absolute inset-0 bg-gradient-to-t from-amber-900/60 via-transparent to-amber-800/30 z-10"></div>

      {/* Port label badge — top right */}
      <div className="absolute top-20 md:top-28 right-4 md:right-10 z-20">
        <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 md:px-4 md:py-2 rounded-full">
          <span className="text-base">{slide.flag}</span>
          <span className="hidden sm:inline">{slide.port}</span>
          <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
        </div>
      </div>

      {/* Main content */}
      <div className="relative z-20 h-full flex flex-col justify-center w-full px-5 md:px-10 pt-16 md:pt-20">
        <div className="w-full max-w-3xl">

          {/* Trust badge */}
          <div className="inline-flex items-center gap-2 bg-white/20 border border-white/40 text-white text-xs font-bold px-3 py-1.5 md:px-4 md:py-2 rounded-full mb-4 md:mb-6 uppercase tracking-widest">
            <i className="ri-global-line"></i>
            <span>World&apos;s #1 Factory-to-Buyer Trade Platform</span>
          </div>

          {/* Headline */}
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-extrabold text-white leading-tight mb-2 drop-shadow-lg">
            {slide.title}
          </h1>

          {/* "Best Platform" — deep dark background for contrast on gold */}
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold mb-4 md:mb-5">
            <span
              className="inline-block text-white px-5 py-1.5 md:px-7 md:py-2 rounded-xl font-extrabold tracking-wide"
              style={{
                background: "linear-gradient(135deg, #7c3a00 0%, #92400e 50%, #78350f 100%)",
                textShadow: "none",
                boxShadow: "0 2px 20px 0 rgba(0,0,0,0.30)",
              }}
            >
              {slide.highlight}
            </span>
          </h2>

          <p className="text-white text-sm md:text-lg mb-5 md:mb-8 leading-relaxed max-w-2xl font-medium drop-shadow">
            {slide.subtitle}
          </p>

          {/* Search bar */}
          <div className="flex flex-col gap-3 mb-5 md:mb-8 w-full max-w-2xl">
            <div className="flex rounded-full overflow-hidden bg-white">
              <input
                type="text"
                placeholder="Search products, factories..."
                className="flex-1 px-4 py-3.5 text-sm text-gray-700 outline-none min-w-0"
              />
              <button
                onClick={() => navigate("/marketplace")}
                className="bg-amber-400 hover:bg-amber-500 transition-colors px-5 md:px-6 flex items-center justify-center cursor-pointer shrink-0"
              >
                <i className="ri-search-line text-white text-lg"></i>
              </button>
            </div>
          </div>

          {/* Quick tags */}
          <div className="hidden sm:flex flex-wrap gap-2 mb-5 md:mb-8">
            {["Solar Panels", "Golf Carts", "E-Bikes", "Faucets", "Apparel", "Garden Tools"].map((tag) => (
              <button
                key={tag}
                onClick={() => navigate("/marketplace")}
                className="bg-white/25 hover:bg-white/40 border border-white/40 text-white text-xs font-semibold px-3.5 py-1.5 rounded-full transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
              >
                {tag}
              </button>
            ))}
          </div>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full max-w-sm sm:max-w-none">
            <button
              onClick={() => navigate(slide.ctaPath)}
              className="flex items-center justify-center gap-2 text-amber-900 font-extrabold px-8 py-4 sm:py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm w-full sm:w-auto"
              style={{background: "linear-gradient(135deg, #fff8e1 0%, #ffffff 50%, #fff3c4 100%)", boxShadow: "0 2px 16px rgba(0,0,0,0.18)"}}
            >
              {slide.cta} <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => navigate("/buyer-post")}
              className="flex items-center justify-center gap-2 bg-white/20 hover:bg-white/30 border-2 border-white/60 text-white font-bold px-8 py-4 sm:py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm backdrop-blur-sm w-full sm:w-auto"
            >
              <i className="ri-file-list-3-line"></i> Post Requirement Free
            </button>
          </div>
        </div>
      </div>

      {/* Stats strip — bottom right, desktop only */}
      <div className="absolute bottom-16 md:bottom-20 right-6 md:right-10 z-20 hidden md:flex flex-col items-end gap-2">
        <div className="bg-white/25 backdrop-blur-sm border border-white/40 rounded-2xl px-5 py-3 text-center">
          <div className="text-2xl font-extrabold text-white drop-shadow">{slide.stat.value}</div>
          <div className="text-white/80 text-xs font-semibold">{slide.stat.label}</div>
        </div>
      </div>

      {/* Slide counter */}
      <div className="absolute top-20 md:top-28 left-5 md:left-10 z-20 hidden md:flex items-center gap-1.5 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-3 py-1.5">
        <span className="text-white font-extrabold text-sm">{current + 1}</span>
        <span className="text-white/60 text-xs">/</span>
        <span className="text-white/80 text-xs">{heroSlides.length}</span>
        <span className="text-white/70 text-xs ml-1">ports worldwide</span>
      </div>

      {/* Slide dots */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-1.5 z-20">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`transition-all duration-300 rounded-full cursor-pointer ${
              i === current ? "w-6 h-2 bg-amber-400" : "w-1.5 h-1.5 bg-white/40 hover:bg-white/70"
            }`}
          />
        ))}
      </div>

      {/* Arrow controls */}
      <button
        onClick={() => goTo((current - 1 + heroSlides.length) % heroSlides.length)}
        className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center bg-white/10 hover:bg-white/25 border border-white/20 rounded-full text-white transition-colors cursor-pointer z-20 backdrop-blur-sm"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={() => goTo((current + 1) % heroSlides.length)}
        className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center bg-white/10 hover:bg-white/25 border border-white/20 rounded-full text-white transition-colors cursor-pointer z-20 backdrop-blur-sm"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      {/* Port flag strip — desktop only, scrollable */}
      <div className="absolute bottom-5 right-4 md:right-10 z-20 hidden lg:flex items-center gap-1.5 max-w-md overflow-x-auto">
        {heroSlides.map((s, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            title={s.port}
            className={`flex items-center gap-1 text-xs font-semibold px-2.5 py-1.5 rounded-full transition-all cursor-pointer whitespace-nowrap shrink-0 ${
              i === current
                ? "bg-amber-400 text-white"
                : "bg-white/10 text-white/70 hover:bg-white/20 border border-white/20"
            }`}
          >
            <span>{s.flag}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
